/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
      this.touched = false; // tracks whether the customer has interacted with the checkbox
      this.injectStyles();
    }

    injectStyles() {
      if (document.getElementById('terms-checkbox-styles')) return; // only inject once

      const style = document.createElement('style');
      style.id = 'terms-checkbox-styles';
      style.textContent = `
        terms-checkbox.terms-checkbox--attention {
          animation: terms-checkbox-shake 0.4s ease-in-out;
        }

        terms-checkbox.terms-checkbox--attention label {
          color: #d0021b !important;
          font-weight: 600 !important;
        }

        terms-checkbox.terms-checkbox--attention input[type="checkbox"] {
          outline: 2px solid #d0021b !important;
          outline-offset: 2px !important;
        }

        @keyframes terms-checkbox-shake {
          0%, 100% { transform: translateX(0); }
          20%, 60% { transform: translateX(-4px); }
          40%, 80% { transform: translateX(4px); }
        }
      `;
      document.head.appendChild(style);
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');

      // Reuse the existing info tooltip (text controlled in the Liquid snippet)
      // instead of creating a separate hardcoded message.
      this.info_tooltip = this.querySelector('label span > div');

      if (this.terms_checkbox) {
        this.terms_checkbox.setCustomValidity('');

        this.terms_checkbox.addEventListener('change', () => {
          this.touched = true;
          this.clearPrompt();

          const attributeValue = this.terms_checkbox.checked ? "Yes" : "No";
          this.updateCartAttribute(attributeValue);
        });
      }

      if (this.terms_checkbox && this.checkout_button) {
        this.checkout_button.addEventListener('click', (event) => {
          event.preventDefault(); // always hold submission first

          if (!this.touched) {
            // Customer hasn't interacted yet — block checkout and draw attention
            this.showPrompt();
            return;
          }

          const attributeValue = this.terms_checkbox.checked ? "Yes" : "No";

          this.updateCartAttribute(attributeValue).then(() => {
            const form = this.checkout_button.form;
            if (form) {
              form.requestSubmit(this.checkout_button);
            } else if (this.checkout_button.tagName === 'A') {
              window.location.href = this.checkout_button.href;
            } else {
              window.location.href = '/checkout';
            }
          });
        });
      }
    }

    showPrompt() {
      this.classList.add('terms-checkbox--attention');
      if (this.info_tooltip) {
        this.info_tooltip.style.display = 'block';
      }
      this.terms_checkbox.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    clearPrompt() {
      this.classList.remove('terms-checkbox--attention');
      if (this.info_tooltip) {
        this.info_tooltip.style.display = 'none';
      }
    }

    updateCartAttribute(attributeValue) {
      return fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Authority to Leave": attributeValue
          }
        })
      })
        .then((response) => {
          if (!response.ok) {
            console.error('Failed to update cart attribute');
          }
          return response;
        })
        .catch((error) => {
          console.error('Error updating cart attribute:', error);
        });
    }
  }

  customElements.define('terms-checkbox', TermsCheckbox);
}